import { useTranslation } from 'react-i18next'

import { useCharlieUser } from 'hooks/useCharlieUser'
import { useGetStrategyQuery } from 'store/strategy/strategyApi'

import { insightsStrategyViewedEvent } from 'utils/analytics/amplitudeEvents'

import { Rocket } from './assets/icons/Rocket'
import { MenuGroup } from './MenuGroup'

export const MenuGroupStrategy = () => {
  const { t } = useTranslation()
  const charlieUser = useCharlieUser()

  const { data: strategy, isSuccess } = useGetStrategyQuery()

  const STRATEY_CODE = 'strategy'
  if (isSuccess) {
    return (
      <MenuGroup
        key={STRATEY_CODE}
        url={`/${STRATEY_CODE}`}
        code={STRATEY_CODE}
        text={t(`nav.${STRATEY_CODE}`)}
        enabled={!!strategy?.committedAt}
        icon={<Rocket />}
        onClick={() => insightsStrategyViewedEvent({}, charlieUser)}
      />
    )
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>
}
